import {createApp, h, ref} from 'vue'
import PopupRoot from './popupRoot.vue'
import {getPopupComponent, preloadPopupComponents} from "@components/popup/register.js";

let popupManager = null

export const usePopup = () => {
    if(popupManager) return popupManager

    let currentStyle = 'V2-PRO' // 默認樣式
    const popupStack = []

    const setStyle = (style) => currentStyle = style

    const show = async (type, options = {}, props) => {
        const Component = await getPopupComponent(type, currentStyle)
        if (!Component) {
            console.warn(`[Popup] 未找到 type: ${type}, style: ${currentStyle}`)
            return null
        }

        const container = document.createElement('div')
        document.body.appendChild(container)

        let close = () => {};
        const app = createApp({
            render() {
                return h(PopupRoot, {
                    component: Component,
                    props,
                    options,
                    setClose: (fn) => close = fn,
                    onClear: () => __clear(app),
                })
            }
        })

        app.mount(container)
        popupStack.push({ app, container })

        return {
            close,
            appInstance: app,
            container,
        }
    }

    const preload = async (path) => {
        if (!path) return
        await preloadPopupComponents(path)
    }

    const __clear = (appInstance) => {
        const index = popupStack.findIndex(p => p.app === appInstance)
        if (index !== -1) {
            const { app, container } = popupStack[index]
            app.unmount()
            if (container.parentNode) {
                container.parentNode.removeChild(container)
            }
            popupStack.splice(index, 1)
        }
    }

    const clearAll = () => {
        while (popupStack.length > 0) {
            const { app, container } = popupStack.pop()
            app.unmount()
            if (container.parentNode) {
                container.parentNode.removeChild(container)
            }
        }
    }

    popupManager = {
        setStyle,
        show,
        preload,
        clearAll,
    }

    return popupManager
}
